import { inject, injectable, interfaces } from 'inversify';
import { EventListeningDisposer, IEventBus } from '../../__legacy__/services/eventBus.service';
import { IProjectHubService } from '../../__legacy__/services/projectHub.service';
import { IAlertBarStore } from './AlertBar.store';
import { Alert } from './models/Alert';
import { AlertsUpdatedEvent, AlertsUpdatedEventType } from './models/AlertsUpdatedEvent';

export interface IAlertBarBl {
  cleanup(): void;
  clearOutdatedAlert(alert: Alert): void;
  initializeAsync(): Promise<void>;
}

export namespace IAlertBarBl {
  export const $: interfaces.ServiceIdentifier<IAlertBarBl> = Symbol('ALERT_BAR_BL');
}

@injectable()
export class AlertBarBl implements IAlertBarBl {
  private alertsUpdatedDisposer?: EventListeningDisposer;
  private userInfoLoadedDisposer?: EventListeningDisposer;

  constructor(
    @inject(IAlertBarStore.$) private readonly alertBarStoreSetter: IAlertBarStore,
    @inject(IProjectHubService.$) private readonly projectHubService: IProjectHubService,
    @inject(IEventBus.$) private readonly eventBus: IEventBus
  ) {}

  handleAlertsUpdated = (event: AlertsUpdatedEvent): void => {
    this.setAlerts(event.alerts);
  };

  async initializeAsync(): Promise<void> {
    await this.projectHubService.initializeAsync();
    this.alertsUpdatedDisposer = this.eventBus.addListener(this.handleAlertsUpdated, AlertsUpdatedEventType);
  }

  cleanup(): void {
    this.alertsUpdatedDisposer?.();
    this.userInfoLoadedDisposer?.();
  }

  clearOutdatedAlert(alert: Alert): void {
    this.alertBarStoreSetter.setAlerts(this.alertBarStoreSetter.alerts.filter((a) => a.id !== alert.id));
  }

  setAlerts(alerts: Alert[]): void {
    this.alertBarStoreSetter.setAlerts(alerts);
  }
}
